import type { NotifiableUserPreferences } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { notificationsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetNotificationSettings() {
  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/me/notification-settings`)
        .get()
        .json<NotifiableUserPreferences>(),
    queryKey: notificationsKeys.settings(),
  });
}
